import { useState, useEffect } from 'react';
import Input from '@/components/inputNew';
import { Autocomplete } from '@react-google-maps/api';
import { GMAPS_TYPES, getGMapsComponent } from '@/utils/GMapsUtils';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';

function InputGMaps({
  id,
  name,
  label,
  error,
  onFocus,
  onChange,
  onBlur,
  value,
}) {
  const [autocomplete, setAutocomplete] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState('');

  useEffect(() => {
    setSelectedPlace(value);
  }, [value]);

  // Se ejecuta cuando el Autocomplete está listo
  const onLoad = (autoC) => {
    setAutocomplete(autoC);
  };

  // Se ejecuta cuando se selecciona una dirección
  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place && place.address_components) {
        const streetNumber = getGMapsComponent(
          place.address_components,
          GMAPS_TYPES.STREET_NUMBER
        );
        const addressSelected = {
          value: place?.address_components,
          streetNumber,
          formattedAddress: place?.formatted_address,
          predictionAddress: place?.formatted_address,
        };
        onChange(addressSelected);
        setSelectedPlace(addressSelected);
      }
    }
  };
  const handleOnInputChange = (data) => {
    const currentValue = data.target.value;
    const addressSelected = {
      value: null,
      streetNumber: '',
      formattedAddress: '',
      predictionAddress: currentValue,
    };
    onChange(addressSelected);
    setSelectedPlace(addressSelected);
  };
  return (
    <>
      <Autocomplete
        onLoad={onLoad}
        onPlaceChanged={onPlaceChanged}
        options={{
          componentRestrictions: { country: 'ES' },
          types: ['address'],
        }}
      >
        <Input
          id={id}
          value={selectedPlace?.predictionAddress || ''}
          name={name}
          label={label}
          onChange={handleOnInputChange}
          onBlur={onBlur}
          onFocus={onFocus}
          preventSubmit
        />
      </Autocomplete>
      {error && (
        <Text
          className="input-google-maps__error"
          text={error}
          color={TEXT_COLOR.RED}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__error`}
        />
      )}
      <style jsx>{`
        @import '../../styles/colors.scss';
        :global(.input-google-maps__error) {
          font-family: Regular;
          font-size: 12px;
          padding: 4px 0 0 12px;
        }
        /* Estilo del contenedor de sugerencias */
        :global(.pac-container) {
          margin: 0px !important;
          padding: 0px !important;
          box-shadow: 0px 3px 6px #0000003b;
          border-radius: 4px;
          padding: 0px !important;
        }

        /* Estilo de cada ítem en la lista */
        :global(.pac-item) {
          font-size: 16px !important;
          font-family: 'Regular' !important;
          padding: 10px 10px 10px 12px !important;
          margin: 0px !important;
          color: $color-gp--grey6 !important;
          border: unset;
        }
        :global(.pac-item-query) {
          font-size: 16px !important;
          font-family: 'Regular' !important;
          color: $color-gp--grey6 !important;
        }
        :global(.pac-matched) {
          font-size: 16px !important;
          font-family: 'Regular' !important;
          color: $color-gp--grey6 !important;
          font-weight: normal !important; /* Anula la negrita */
        }
        /* Cambiar color de fondo al pasar el mouse */
        :global(.pac-item:hover) {
          background-color: $color-gp--grey1 !important;
        }
        :global(.pac-item-selected) {
          background-color: $color-gp--grey2 !important;
        }
        /* Cambiar color de fondo al pasar el mouse */
        :global(.pac-icon) {
          display: none !important;
        }
        :global(.pac-container::after) {
          opacity: 0.3 !important;
        }
      `}</style>
    </>
  );
}

export default InputGMaps;
